module.exports = __webpack_public_path__ + "media/images/refersion-2c55083aa638150c01f080ff59125c89.svg";